import axios, { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';

import { ResponseList } from 'models/Response';
import { RoleMaster } from 'models/role';

export type UseMasterRoleProps = {
    sid?: string;
    id?: string;
    menuId?: string;
};

export function useMasterRole(props?: UseMasterRoleProps) {
    const { sid, id, menuId } = props || {};

    return useQuery({
        queryKey: ['master-role', { sid, id, menuId }],
        queryFn: ({ signal }) => {
            const accessToken = localStorage.getItem('WF_APPLICATION');

            return axios.get<ResponseList<RoleMaster>>(
                '/v1/configuration/workflow/role',
                {
                    signal,
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    params: {
                        sid,
                        id,
                        menu_id: menuId
                    }
                }
            );
        },
        select: (response: AxiosResponse<ResponseList<RoleMaster>>) =>
            response.data.result_list,
        retry: 1
    });
}
